import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';
import { DashboardResponse } from '../types/dashboard';

export const settingsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getDashboardSummary: build.query<DashboardResponse, void>({
      query: () => ({
        url: appEndpoint.dashboardSummary,
        method: 'get',
      }),
      providesTags: ['dashboardSummary'],
    }),

  

    changePassword: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.changePassword}`,
        data:data.body,
        method: "put",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useChangePasswordMutation,
  useGetDashboardSummaryQuery
} = settingsApi;